import { render, staticRenderFns } from "./ModalFaqEdit.vue?vue&type=template&id=42e580fd&"
import script from "./ModalFaqEdit.vue?vue&type=script&lang=js&"
export * from "./ModalFaqEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports